import { UPDATE_PAYMENT_PACKAGE } from "..";
import { apiInstance } from "../config/apiInstance";

export type UpdatePaymentPackageItem = {
  id: number;
  budgetCertificate: string;
  budgetRegistration: string;
};

export type UpdatePaymentPackageRequest = {
  items: UpdatePaymentPackageItem[];
};

export type UpdatePaymentPackageResponse = {
  id: number;
  consecutive: string;
};

export const updatePaymentPackage = async (
  data: UpdatePaymentPackageRequest,
): Promise<UpdatePaymentPackageResponse> => {
  const response = await apiInstance.put<UpdatePaymentPackageResponse>(
    UPDATE_PAYMENT_PACKAGE,
    data,
  );
  return response.data;
};
